import IndigoServiceClient from 'communication/IndigoServiceClient';
import { ApiRequestOptions } from 'communication/ApiCallInfo';
import IndigoApiError from 'communication/IndigoApiError';
import { DarkVenueHeatmapApiRequest } from './DarkVenueHeatmapApiRequest';
import { DarkVenueHeatmapApiResponse } from './DarkVenueHeatmapApiResponse';

export async function callDarkVenueHeatmapApi(
    indigoServiceClient: IndigoServiceClient,
    request: DarkVenueHeatmapApiRequest,
    options: ApiRequestOptions
): Promise<DarkVenueHeatmapApiResponse> {
    const url = 'darkVenueHeatmap/' + request.instinetSymbol;

    return await IndigoApiError.runHandlingErrorsAsync(
        `Dark Venue Heatmap`,
        async () => {
            return await indigoServiceClient.get(url, options);
        }
    );
}
